function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 66 42"
}, props),
/*#__PURE__*/
React.createElement("path", {
  d: "M58.736 17.257V9.98h-5.189v7.277h-7.472v5.198h7.472v7.486h5.189v-7.486H66v-5.198h-7.264zm-37.774-.415v8.316s8.054-.01 11.333-.01c-1.776 5.391-4.537 8.327-11.333 8.327-6.877 0-12.245-5.585-12.245-12.475S14.085 8.525 20.962 8.525c3.636 0 5.985 1.28 8.139 3.065 1.724-1.728 1.58-1.974 5.967-6.124A20.865 20.865 0 0020.962 0C9.385 0 0 9.402 0 21s9.385 21 20.962 21c17.305 0 21.535-15.095 20.132-25.158H20.962z",
  fillRule: "evenodd"
})));